import fetcher from '../lib/fetcher'
import useAppStore from '../store'
import {
  TForgetPasswordResponse,
  TLoginResponse,
  TRefreshTokenResponse,
  TResetPasswordResponse,
} from '../types/auth.type'
import {StorageService} from './storage.services'

const register = async (data: any) => {
  return fetcher.post(`/api/auth/register`, data)
}

const login = async (data: {
  email: string
  password: string
}): Promise<TLoginResponse> => {
  const response = await fetcher.post<typeof data, TLoginResponse>(
    `/api/auth/login`,
    data,
  )
  return response.data as TLoginResponse
}

const forgetPassword = async (email: string) => {
  const response = await fetcher.post<{email: string}, TForgetPasswordResponse>(
    `/api/auth/forgot-password`,
    {email},
  )
  return response.data
}

const resetPassword = async ({
  token,
  password,
  passwordConfirmation,
}: {
  token: string
  password: string
  passwordConfirmation: string
}) => {
  const response = await fetcher.post<
    {token: string; password: string; passwordConfirmation: string},
    TResetPasswordResponse
  >(`/api/auth/reset-password`, {token, password, passwordConfirmation})
  return response.data
}

const refreshAccessToken = async (refreshToken: string) => {
  const response = await fetcher.post<
    {refreshToken: string},
    TRefreshTokenResponse
  >(`/api/auth/refresh-token`, {refreshToken})
  return response.data
}

const logout = () => {
  StorageService.setAuthAccess(null)
  useAppStore.setState({user: null})
  window.location.href = '/auth/login'
}

export const AuthService = {
  register,
  login,
  forgetPassword,
  resetPassword,
  refreshAccessToken,
  logout,
}
